var cilElevator = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M256,30.4,96,168.681V232H416V168.681ZM384,200H128V183.319L256,72.7,384,183.319Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M96,343.319,256,481.6,416,343.319V280H96ZM128,312H384v16.681L256,439.3,128,328.681Z' class='ci-primary'/>"];

export { cilElevator };

